<div class="navigation">
  <ul>
    <li class="navigation-list">
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>
      <a [routerLink]="['/browse']">Browse</a>
    </li>
    <li>
      <a [routerLink]="['/wikipedicat']">Catinder</a>
    </li>
  </ul>
</div>
